const CLAIM_ERROR = 'CLAIM_ERROR'
const CLAIM_REQUESTING = 'CLAIM_REQESTING'
const CLAIM_SUCCESS = 'CLAIM_SUCCESS'
const DISABLE_INPUTS = 'DISABLE_INPUTS'

export {
  CLAIM_ERROR,
  CLAIM_REQUESTING,
  CLAIM_SUCCESS,
  DISABLE_INPUTS
}
